module.exports = __webpack_public_path__ + "ico/64.png";